import React from "react";
import { Link } from "react-router-dom";

import { CAMPAIGN_FOCUS_RING_CLASS } from "../constants/campaignTheme";
import { useCharityHomeRoute } from "../hooks/useCharityHomeRoute";

import { CharityCampaignMark } from "./CharityCampaignMark";

interface CharityLogoProps {
  className?: string;
}

/**
 * Ride to Rebuild logo — the campaign mark and wordmark, linking back to the
 * campaign home page. Home is the leaderboard once a participant is signed in,
 * so the logo is the one control every sub page carries for getting back there
 * directly.
 *
 * @param className - Extra classes for the anchor wrapping the logo
 * @returns The linked campaign logo
 */
export const CharityLogo: React.FC<CharityLogoProps> = ({ className = "" }) => {
  const homeRoute = useCharityHomeRoute();

  return (
    <Link
      to={homeRoute}
      aria-label="Ride to Rebuild — back to home"
      className={`inline-flex items-center gap-2 rounded-[5px] ${CAMPAIGN_FOCUS_RING_CLASS} ${className}`}
    >
      <CharityCampaignMark />
      <span className="text-base font-extrabold leading-tight tracking-[-0.01em] text-[#F6F4F0] sm:text-lg">
        Ride to Rebuild
      </span>
    </Link>
  );
};
